import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-300 pt-14 md:pt-16 pb-8">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 pb-10 border-b border-foreground-800">
          <div>
            <h3 className="text-lg font-heading font-bold text-white mb-4">吃瓜网每日大赛</h3>
            <p className="text-sm leading-relaxed text-foreground-400">
              {footerData.intro}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerData.links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick(link.href);
                  }}
                  className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">{footerData.partnersLabel}</h4>
            <p className="text-sm text-foreground-500">合作伙伴信息即将上线，敬请期待。</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 吃瓜网每日大赛. 本站内容仅供娱乐参考，不构成事实认定。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}